import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function AccessDenied() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 3000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div
      className="flex flex-column align-items-center justify-content-center"
      style={{ minHeight: "50vh" }}
    >
      <i
        className="pi pi-lock"
        style={{ fontSize: "4rem", color: "var(--red-500)" }}
      />
      <h2>Access Denied</h2>
      <p>You do not have permission to view this page.</p>
      <p className="text-500">You will be redirected to the home page...</p>
    </div>
  );
}
